<div [formGroup]="form" class="flex flex-col gap-4">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <app-form-field
      id="legalCompanyName"
      fieldName="legalCompanyName"
      label="common.legalCompanyName"
    ></app-form-field>

    <app-form-field id="legalForm" fieldName="legalForm" label="common.legalForm"></app-form-field>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div class="flex flex-col gap-2">
      <label for="country">
        {{ 'common.country' | transloco }}
        <span>*</span>
      </label>
      <app-country-select
        formControlName="country"
        [placeholder]="'common.country' | transloco"
        testId="country-select"
        [ngClass]="{
          'p-invalid': countryInvalid(),
        }"
      ></app-country-select>
      @if (countryInvalid()) {
        <p-message severity="error" variant="simple" size="small" data-testid="country-error">
          {{ 'account.validation.requiredField' | transloco }}
        </p-message>
      }
    </div>

    <app-form-field id="zipCode" fieldName="zipCode" label="common.zipCode"></app-form-field>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <app-form-field id="city" fieldName="city" label="common.city"></app-form-field>

    <app-form-field
      id="additionalInformation"
      fieldName="additionalInformation"
      label="common.additionalInformation"
    ></app-form-field>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <app-form-field id="street" fieldName="street" label="common.street"></app-form-field>

    <app-form-field id="number" fieldName="number" label="common.number"></app-form-field>
  </div>

  <app-form-field id="vatNumber" fieldName="vatNumber" label="common.vatNumber"></app-form-field>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <app-form-field
      id="invoiceEmail"
      fieldName="invoiceEmail"
      label="common.invoiceEmail"
      type="email"
      placeholder="beispiel@email.com"
    ></app-form-field>

    <app-form-field
      id="responsibleForInvoices"
      fieldName="responsibleForInvoices"
      label="common.responsibleForInvoices"
      type="email"
      placeholder="beispiel@email.com"
    ></app-form-field>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <app-form-field
      id="costCenter"
      fieldName="costCenter"
      label="common.costCenter"
    ></app-form-field>

    <app-form-field
      id="internalInformation"
      fieldName="internalInformation"
      label="common.internalInformation"
    ></app-form-field>
  </div>
</div>
